import styled from 'styled-components';
import {alignContentCss} from '../../styles/align.styled';
import {boxCss} from '../../styles/box.styled';


export const ButtonListStyled = styled.div`
  ${boxCss};

  .dfl-image-list {
    display: flex;
    flex-wrap: wrap;

    ${alignContentCss}
    > div {
      min-width: 191px;
      margin-right: 18px;
    }
    > div:last-child {
      margin-right: 0px;
    }
  }
`;

